import Constants from '@/Constants';
import { LessonEnrollment } from '@/models/LessonEnrollment';
import { Questionnaire } from '@/models/Questionnaire';
import { ApplicationState } from '@/store';
import { useSelector } from 'react-redux';
import { useSWRConfig } from 'swr';
import { useGet } from '../useGet';

interface Props {
    evaluationId?: number;
    classEnrollmentId?: number;
    lessonEnrollment?: LessonEnrollment;
}

const getKey = (evaluationId: number | undefined, classEnrollmentId: number | undefined, personId: number): string | null => {
    if (!evaluationId || !classEnrollmentId || !personId) {
        return null;
    }

    return `${Constants.EVALUATION_QUESTIONNAIRES_BY_ID_URI.replace(
        '%e',
        evaluationId.toString(),
    )}?dynamicAttributes={"path": "classEnrollmentId", "value": "${classEnrollmentId}"}&personId=${personId}`;
};

export const useQuestionnaires = ({ evaluationId, classEnrollmentId }: Props) => {
    const { cache } = useSWRConfig();

    const personId: number = useSelector((state: ApplicationState) => state.identity.data.person.id || 0);

    const { data: questionnaires, loading, revalidateResult: reloadQuestionnaires } = useGet<Questionnaire[]>(
        getKey(evaluationId, classEnrollmentId, personId),
    );

    const clear = (): void => {
        cache.delete(getKey(evaluationId, classEnrollmentId, personId));
    };

    return { questionnaires, loading, clear, reloadQuestionnaires };
};
